import axios from "axios";

const state = {
  currentStaticPage: {},
  staticPages: [],
  pagination: {
    page: 1,
    itemsPerPage: 25,
    sortBy: ["label"],
    sortDesc: [],
    groupBy: [],
    groupDesc: [],
    mustSort: false,
    multiSort: false,
    totalItems: 0,
    rowsPerPageOptions: [25, 50, 75, 100]
  }
};

const actions = {
  getAllStaticPages: ({ commit, dispatch, state }) => {
    const sortingOrder = state.pagination.sortDesc[0] ? "desc" : "asc";
    return axios.get(`/static-pages`, {
      params: {
        page: state.pagination.page,
        per_page: state.pagination.itemsPerPage,
        sort: state.pagination.sortBy[0],
        order: sortingOrder
      }
    })
      .then((resp) => {
        commit("getAllStaticPagesSuccess", resp.data.staticPages);
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", "Unable to retrieve static pages", { root: true });
        return Promise.reject(err);
      });
  },
  getStaticPage: ({ commit, dispatch }, id) => {
    return axios.get(`/static-pages/${id}`)
      .then((resp) => {
        commit("setCurrentStaticPageData", resp.data.staticPage);
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  updateStaticPage: ({ dispatch, state }) => {
    return axios.patch(`/static-pages/${state.currentStaticPage.id}`, state.currentStaticPage)
      .then((resp) => {
        dispatch("snackbar/successMessage", `Successfully updated static page`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  },
  uploadStaticPageImage: ({ dispatch, state }, formData) => {
    return axios.post(`/static-pages/${state.currentStaticPage.id}/image`, formData)
      .then((resp) => {
        dispatch("getStaticPage", state.currentStaticPage.id);
        dispatch("snackbar/successMessage", `Successfully uploaded image`, { root: true });
        return resp;
      })
      .catch((err) => {
        dispatch("snackbar/errorMessage", err, { root: true });
        return Promise.reject(err);
      });
  }
};

const mutations = {
  setStaticPagePagination: (state, payload) => {
    state.pagination = payload;
  },
  getAllStaticPagesSuccess: (state, staticPages) => {
    state.staticPages = staticPages.data;
    state.pagination.totalItems = staticPages.total;
  },
  setCurrentStaticPageData: (state, staticPage) => {
    state.currentStaticPage = staticPage;
  }
};

export default {
  state,
  actions,
  mutations
};
